export default __webpack_public_path__ + "static/Cloud-Deployment-0ef337b2cc0def3797c68cbf250b2fff.webp";